import {Component, OnInit} from "@angular/core";

/**
 *  `PitPageFooterComponent` - общий футер для всех страниц приложения.
 **/
@Component({
  selector: 'pit-page-footer',
  templateUrl: './pit-page-footer.component.html',
  styleUrls: ['./pit-page-footer.component.css']
})
export class PitPageFooterComponent implements OnInit {

  constructor() {}

  ngOnInit(): void {}
}
